module.exports = __webpack_public_path__ + "static/media/T2.34a29232.jpg";